const formatNumber = (num) => {
  return num.toLocaleString('es-CL', { minimumFractionDigits: 0 });
}

const getCartData = async () => {
  const response = await fetch('/cart.js')
  const data = await response.json();

  return data
}

const getUserData = () => {
  const userData = document.querySelector("#user-data").textContent

  return JSON.parse(userData)
}

const generatePDF = (str) => {
  const doc = new jsPDF('p', 'pt', 'letter');
  const parser = new DOMParser();
  const docHTML = parser.parseFromString(str, 'text/html');
  const table = docHTML.querySelector('body');
  const scale = (doc.internal.pageSize.width - 10 * 2) / document.body.clientWidth;
  doc.html(table, {
    callback: function (doc) {
      doc.save("Cotización.pdf");
    },
    html2canvas: {
      scale: 0.38
    },
    x: 10,
    y: 10
  });
}

const generateExcel = (str, user) => {
  const date = new Date();
  const year = date.getFullYear()
  const day = date.getDate()
  const month = date.getMonth() + 1

  const container = document.createElement('div');
  container.innerHTML = str;
  const table = container.querySelector("#table-quote");

  const dateRow = table.insertRow(0);
  const userRow = table.insertRow(1);
  const emailRow = table.insertRow(2);
  const rutRow = table.insertRow(3);
  table.insertRow(4);
  const dateCell = dateRow.insertCell(0);
  const userCell = userRow.insertCell(0);
  const emailCell = emailRow.insertCell(0);
  const rutCell = rutRow.insertCell(0);

  dateCell.textContent = `Fecha: ${day}/${month}/${year}`
  userCell.textContent = `Hecho para: ${user.first_name} ${user.last_name}`
  emailCell.textContent = `Email: ${user.email}`
  rutCell.textContent = `Rut: ${user.rut}`

  const exporter = new TableExport(table, {
    formats: ['xlsx'],
    exportButtons: false
  });

  const data = exporter.getExportData();

  const xlsxData = data['table-quote'].xlsx;
  exporter.export2file(xlsxData.data, xlsxData.mimeType, 'quote', xlsxData.fileExtension);
}

const buildQuotePdf = (user, cart) => {
  // Seleccionar todos los elementos con la clase 'bold_cart_item_total'
  const items2 = document.querySelectorAll(".cart_item_total");

  // Obtener los valores de 'data-price' de cada elemento
  const prices_item = Array.from(items2).map(item => item.getAttribute('data-price'));
  const prices = Array.from(items2).map(item => item.getAttribute('data-price_without'));

  const barCodes = document.querySelectorAll(".cart-item__totals.small-hide .price.price--end");
  const subtotalElement = document.getElementById("subtotal");
  const totalCart_subtotal = subtotalElement.getAttribute("data-cart__total");
  const ivaElement = document.getElementById("subtotal_iva");
  const iva_subtotal = ivaElement.getAttribute("data-iva");
  const totalElement = document.getElementById("total");
  const total = totalElement.getAttribute("data-cart_total");


  let items = ''
  const date = new Date();
  const year = date.getFullYear()
  const day = date.getDate()
  const month = date.getMonth() + 1


  cart.items.forEach((item, i) => {
    items += `
      <tr>
        <td> <img src="${item.image}" height="100" width="100" /> </td>
        <td style="width: 500px">${item.title}</td>
        <td>${item.sku}</td>
        <td> ${barCodes[i].dataset.barcode} </td>
        <td>${item.quantity}</td>
        <td> ${prices_item[i]}</td>
      </tr>
    `
  });

  const template = `
    <div style="width:1500px; margin: auto;">
      <div style="display:flex; justify-content: space-between;">
        <div>
          <h1>Cotización</h1>
          <p>Fecha: ${day}/${month}/${year}</p>
          <p>Hecho para: ${user.first_name} ${user.last_name}</p>
          <p>Email: ${user.email}</p>
          <p>Rut: ${user.rut}</p>
        </div>
        <div> <img src="https://cdn.shopify.com/s/files/1/0012/1661/0359/files/logo.png?v=1613160470" width="150" /> </div>
      </div>

      <table style="margin: auto;" id="table-quote">
        <tr>
          <th></th>
          <th>Producto</th>
          <th>SKU</th>
          <th>UPC</th>
          <th>Cantidad</th>
          <th>Total línea</th>
        </tr>
        ${items}
        <tr>
        <td colspan="5">Subtotal</td>
        <td> ${totalCart_subtotal} </td>
      </tr>
      <tr>
        <td colspan="5">IVA</td>
        <td> ${iva_subtotal} </td>
      </tr>
      <tr>
        <td colspan="5">Total</td>
        <td> ${total} </td>
      </tr>
      </table>
    </div>
  `

  return template
}

const buttonListener = () => {
  const button = document.querySelector("#generate-quote")

  button.addEventListener("click", async () => {

    const userData = getUserData()
    const cartData = await getCartData()

    const template = buildQuotePdf(userData, cartData)
    generatePDF(template)
  })
}

const buttonExcelListener = () => {
  const button = document.querySelector("#generate-quote-excel")

  button.addEventListener("click", async () => {

    const userData = getUserData()
    const cartData = await getCartData()

    const template = buildQuotePdf(userData, cartData)
    generateExcel(template, userData)
  })
}

buttonListener();
buttonExcelListener();